var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 512,
    viewBox: "0 0 384 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0835 0H238.435L383.44 151.358V445.291C383.44 482.102 353.729 512 316.917 512H67.0835C30.4587 512 0.561035 482.102 0.561035 445.291V66.5225C0.560388 29.8976 30.4587 0 67.0835 0V0Z",
    fill: "#00733B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.248 0V150.05H383.44L238.248 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.766 372.789H134.914L117.91 344.199L100.905 372.789H75.866L105.39 323.083L79.4169 279.918H104.456L117.909 302.342L131.176 279.918H156.216L130.428 323.27L159.766 372.789ZM168.549 372.789V279.918H192.28V352.607H232.642V372.788H168.549V372.789ZM271.883 373.91C262.54 373.91 254.318 370.92 247.218 365.127C240.304 359.521 236.38 352.421 235.819 344.012L256.187 338.033C256.748 342.517 258.616 346.441 261.793 349.431C265.157 352.421 268.894 353.916 273.005 353.916C276.368 353.916 279.171 353.169 281.413 351.674C283.469 350.179 284.59 348.123 284.59 345.694C284.59 343.639 283.656 341.957 281.974 340.462C280.292 339.154 278.049 338.033 275.433 337.099C272.817 336.165 269.641 335.23 266.464 334.483C263.101 333.549 259.737 332.427 256.56 330.932C253.197 329.624 250.207 327.942 247.591 325.887C244.788 324.018 242.733 321.216 241.051 317.665C239.369 314.302 238.435 310.19 238.435 305.519C238.435 297.858 241.611 291.504 248.151 286.459C254.691 281.227 262.54 278.798 271.696 278.798C280.852 278.798 288.887 281.04 295.614 285.338C302.341 289.823 306.638 295.616 308.32 302.716L287.018 311.686C286.084 307.761 284.215 304.585 281.599 302.156C278.983 299.914 275.62 298.606 271.696 298.606C268.706 298.606 266.463 299.353 264.595 300.475C262.913 301.596 262.166 303.278 262.166 305.333C262.166 307.202 263.287 308.883 265.529 310.191C267.771 311.312 270.761 312.246 274.125 312.807C277.488 313.368 281.225 314.302 285.149 315.61C289.26 317.105 292.811 318.6 296.361 320.656C299.724 322.524 302.527 325.701 304.769 329.812C307.199 334.11 308.32 339.155 308.32 344.948C308.32 353.543 304.956 360.644 298.229 365.876C291.502 371.107 282.721 373.91 271.883 373.91V373.91Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.30b4ed5112a1c63ce8308acbff31deba.svg";
export { ForwardRef as ReactComponent };